<template>
    <div v-if="lastPage !== 1"
         class="parametric-pagination">
        <Paginate v-model="currentPage"
                  :page-count="lastPage"
                  :page-range="3"
                  :margin-pages="1"
                  :click-handler="_changePage"
                  prev-text=" "
                  next-text=" "
                  container-class="parametric-pagination__wrapper"
                  page-class="parametric-pagination__item"
                  prev-class="parametric-pagination__item parametric-pagination__item-prev"
                  next-class="parametric-pagination__item parametric-pagination__item-next"
                  active-class="is-active"
                  disabled-class="is-disabled">
        </Paginate>
    </div>
</template>

<script>
import Paginate from 'vuejs-paginate';
import {mapActions, mapGetters} from 'vuex';

/**
 * Компонент для вывода пагинации
 */
export default {
    name: 'ParametricPagination',

    components: {
        Paginate
    },

    props: {
        /**
         * Текущая выбранная страница
         */
        currentPage: {
            type   : Number,
            default: 1
        },
        /**
         * Последняя страница
         */
        lastPage: {
            type   : Number,
            default: 1
        }
    },

    computed: {
        ...mapGetters({
            activeType: 'parametric/GET_ACTIVE_TYPE', // текущий выбранный тип для показа пагинации
        }),
    },

    watch: {
        currentPage() {
            this.$forceUpdate();
        }
    },

    methods: {
        ...mapActions('parametric', ['changePage', 'sendSortAndPaginationRequest']),

        /**
         * Событие при смене страницы
         * @param page
         * @private
         */
        _changePage(page) {
            const body = {
                type    : 'pagination',
                category: this.activeType,
                page
            };

            this.changePage(body);
            this.sendSortAndPaginationRequest(false)
                .then(() => {
                    this.$emit('onChangePage');
                });
        }
    }
};
</script>

<style lang="scss">
@import "ParametricPagination";
</style>
